import { formatDurationTime } from 'src/app/helpers/format';
import { LiveForSchema } from 'src/app/models/live';
import { VideoForSchema } from 'src/app/models/video';

export const getWebsiteInfo = (): string => {
  const websiteInfo = {
    '@context': 'http://schema.org',
    '@type': 'Website',
    'author': [
      {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        'address': 'Menara Palma Annex Building P11 H. R. X2 Kav 6, Jalan Haji R. Rasuna Said, Daerah Khusus Ibukota Jakarta 12950',
        'contactPoint': [{
          '@type': 'ContactPoint',
          'contactType': 'customer service',
          'telephone': '+62-21-2922-3600'
        }],
        'legalName': 'PT. Darta Media Indonesia',
        'logo': 'https://www.kaskus.co.id/e3.1/images/layout/home-logo-n.png',
        'name': 'KASKUS',
        'url': 'https://www.kaskus.co.id'
      }
    ],
    'name': 'KASKUS TV',
    'potentialAction': {
      '@type': 'SearchAction',
      'query-input': 'required name=search_term_string',
      'target': 'https://tv.kaskus.co.id/search/{search_term_string}'
    },
    'url': 'https://tv.kaskus.co.id'
  };

  return JSON.stringify(websiteInfo);
};

export const getVideoSchema = (video: VideoForSchema, fullAppUrl: string): string => {
  const videoContent = {
    '@context': 'http://schema.org',
    '@type': 'VideoObject',
    'contentUrl': fullAppUrl,
    'description': video.description,
    'duration': formatDurationTime(video.duration, 'iso'),
    'embedUrl': video.embedUrl,
    'interactionCount': video.viewCount,
    'name': video.title,
    'publisher': {
      '@type': 'Organization',
      'logo': {
        '@type': 'ImageObject',
        'height': 60,
        'url': video.channel.avatar,
        'width': 60
      },
      'name': video.channel.name
    },
    'thumbnailUrl': video.largeThumbnail,
    'uploadDate': video.publishedAt
  };

  return JSON.stringify(videoContent);
};

export const getLiveSchema = (live: LiveForSchema, fullAppUrl: string): string => {
  const durationApproximation = formatDurationTime(3600000, 'iso'); // 1 hour
  const endDateApproximation = new Date(new Date(live.publishedAt).getTime() + 3600000).toISOString();
  const liveInfo = {
    '@context': 'http://schema.org',
    '@type': 'VideoObject',
    'contentUrl': fullAppUrl,
    'description': live.description,
    'duration': durationApproximation,
    'embedUrl': live.embedUrl,
    'expires': endDateApproximation,
    'interactionCount': live.viewCount,
    'name': live.title,
    'publication': {
      '@type': 'BroadcastEvent',
      'endDate': endDateApproximation,
      'isLiveBroadcast': true,
      'startDate': live.publishedAt
    },
    'publisher': {
      '@type': 'Organization',
      'logo': {
        '@type': 'ImageObject',
        'height': 60,
        'url': live.program.channel.avatar,
        'width': 60
      },
      'name': live.program.channel.name
    },
    'thumbnailUrl': live.largeThumbnail,
    'uploadDate': live.publishedAt
  };

  return JSON.stringify(liveInfo);
};
